import { render, staticRenderFns } from "./BButton.vue?vue&type=template&id=457017ba"
import script from "./BButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BButton.vue?vue&type=style&index=0&id=457017ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports